import React, { useState } from "react";

const Timeline = () => {
  return (
    <section className="design-section">
        <div className="timeline">
            <div className="timeline-empty">
            </div>

            <div className="timeline-middle">
            <div className="timeline-circle"></div>
            </div>
            <div className="timeline-component timeline-content">
                <h3>В феврале 2025</h3>
                <p>Пилотный запуск проекта</p>
            </div>
            <div className="timeline-component timeline-content">
                <h3>В марте 2025</h3>
                <p>Оптимизировать поиск и заказ товаров, расширить возможности платформы</p>
            </div>
            <div className="timeline-middle">
                <div className="timeline-circle"></div>
            </div>

            <div className="timeline-empty">
            </div>

            <div className="timeline-empty">
            </div>

            <div className="timeline-middle">
                <div className="timeline-circle"></div>
            </div>

            <div className=" timeline-component timeline-content">
                <h3>В апреле 2025</h3>
                <p>Расширить категории товаров: масла, аксессуары, инструменты и т.п.</p>
            </div>

            <div className="timeline-component timeline-content">
                <h3>В мае 2025</h3>
                <p>Завершить подключение к платформе всех ведущих поставщиков автозапчастей</p>
            </div>
            <div className="timeline-middle">
                <div className="timeline-circle"></div>
            </div>

            <div className="timeline-empty">
            </div>

            <div className="timeline-empty">
            </div>

            <div className="timeline-middle">
                <div className="timeline-circle"></div>
            </div>

            <div className=" timeline-component timeline-content">
                <h3>Июль 2025</h3>
                <p>Добавить весь планируемый функционал для Вашего удобства при работе с платформой</p>
            </div>

            <div className="timeline-component timeline-content">
                <h3>В 2026 году</h3>
                <p>Не останавливаться на достигнутом</p>
            </div>
            <div className="timeline-middle">
                <div className="timeline-circle"></div>
            </div>

            <div className="timeline-empty">
            </div>

            <div className="timeline-empty">
            </div>

            
        </div>
    </section>
  );
};

export default Timeline;
